var map = {
	"./appointment-form/appointment-form.module": [
		"./src/app/user-area/appointment-form/appointment-form.module.ts",
		"appointment-form-appointment-form-module"
	],
	"./appointment-list/appointment-list.module": [
		"./src/app/user-area/appointment-list/appointment-list.module.ts",
		"appointment-list-appointment-list-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./section/section.module": [
		"./src/app/section/section.module.ts",
		"section-section-module"
	],
	"./user-area/user-area.module": [
		"./src/app/user-area/user-area.module.ts",
		"user-area-user-area-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;